/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const AcknowledgeIncidentBody = zod.object({});

export type AcknowledgeIncidentBody = zod.input<typeof AcknowledgeIncidentBody>;
export type AcknowledgeIncidentBodyOutput = zod.output<typeof AcknowledgeIncidentBody>;
